import { boxShadow } from '../global';

const ListCompanyCustomLayoutStyle = (theme) => ({
    room: {
        padding: '15px 0',
        '&:hover': {
            transition: 'all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)',
            ...boxShadow,
        },
    },
    items: {
        position: 'relative',
        display: 'block',
        overflow: 'hidden',
        marginLeft: '10px',
        marginRight: '10px',
        border: '1px solid rgba(0,0,0,0.2)',
        borderRadius: '10px',

        '&:before': {
            display: 'block',
            paddingTop: '100%',
            content: '""',
        },
        [theme.breakpoints.up('sm')]: {
            height: '150px',
            width: '150px',
        },
    },
    content: {
        [theme.breakpoints.up('sm')]: {
            width: 'calc(100% - 170px)',
            height: '150px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
        },
    },
    productItemImg: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '10px',
    },
    listProfile: {
        alignItems: 'end',
    },
    listProfileName: {
        color: (props) => props?.text_color_company_name || '#ed735b',
        textTransform: 'uppercase',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
        display: '-webkit-box',
    },
    listContent: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '-webkit-line-clamp': 3,
        '-webkit-box-orient': 'vertical',
        display: '-webkit-box',
        fontSize: '16px',
    },
    listAction: {
        display: 'flex',
        justifyContent: 'end',
        padding: '0px 0px 0px 10px',
        alignItems: 'end',
    },
    listProfileContent: {
        paddingLeft: '0px',
        display: 'flex',
        alignItems: 'end',
    },
    listProfileIndustry: {
        padding: '10px 0',
        fontSize: '18px',
    },
    buttonAddFavorite: {
        '& > span > svg': {
            marginRight: '0px',
        },
        borderRadius: '5px',
        fontWeight: 'bold',
        fontSize: '14px',
    },
});

export default ListCompanyCustomLayoutStyle;
